import { TooltipService } from './tooltip.service';
import { Directive, HostListener, Input } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Directive({
  selector: "[appTooltipToggler]"
})
export class TooltipTogglerDirective {
  private isMobile = false;
  private isTable = false;
  private isDesktop = false;

  @Input("appTooltipToggler") tooltipRef: HTMLElement;
  @Input("tooltipText") tooltipText: string;

  constructor(
    private deviceService: DeviceDetectorService,
    private ts: TooltipService
  ) {
    this.isMobile = deviceService.isMobile();
    this.isTable = deviceService.isTablet();
    this.isDesktop = deviceService.isDesktop();
  }

  @HostListener("mouseenter") onMouseEnter() {
    if (this.isDesktop) {
      this.onToggleTooltip(true);
    }
  }

  @HostListener("mouseleave") onMouseLeave() {
    if (this.isDesktop) {
      this.onToggleTooltip(false);
    }
  }

  @HostListener("touchstart") onTouchStart() {
    if (this.isMobile || this.isTable) {
      this.onToggleTooltip(true);
    }
  }

  @HostListener("touchend") onTouchEnd() {
    if (this.isMobile || this.isTable) {
      this.onToggleTooltip(false);
    }
  }

  private onToggleTooltip(show: boolean) {
    if (this.tooltipText) {
      this.ts.setTooltipData(this.tooltipText, show, this.tooltipRef, true);
    }
  }
}
